import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';
import { ActivatedRoute, Router } from '@angular/router';
import { WompiService } from '../../services/wompi.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SocketIoService } from './../../services/socket-io.service';

@Component({
	selector: 'app-devops',
	templateUrl: './devops.component.html',
	styleUrls: ['./devops.component.scss']
})
export class DevopsComponent implements OnInit {
	public path1 = {
		code: "A1",
		path: "M593 203.5l-1.6 0.3-2.6 1.1-1.1 0.3-1.2 0.2-1.2-0.1-1-0.2-1.2-0.5-1-0.2-1.3 0.2-1.2 0.5-1 0.3-0.6-0.3-0.4-1.2-0.4-1-0.8-0.9-1.3-0.4 0.4-0.8 0.4-0.7 0.8-0.4 1.3-2.5 0.9-0.5 0.8-2.4 0.9-1.1 0.6-1.6 0.3-0.8 0.8-1.1-0.7-1.1-2.6-2.2-2.7-1.6-2-0.5-1.8-1.1-2-0.6-0.5-1 0.1-0.7 0.3-0.9 0.1-0.8-0.3-1.8-0.3-1.2-0.8-1.1-0.9-0.6-1.2 0.1-2.4-0.5-1.8-0.1-1.5-0.3-4.4-0.2-10.3 1.4-1.4-5-0.4-2.8-0.3-0.9-0.8-1.3-0.1-0.5 0-0.7 0.4-1.7 0.4-1 0.2-3.6 0.1-0.8 0-0.8-0.2-1 0.4-0.7 1-0.3 0.3-0.3 0.9-1.2 0.8-0.5 0.3-0.6 1.3-3.9-0.2-1.9 11 0 7.4-1.2 0.6-0.4 0.5-0.6 2-1.5 1.7-1 0.9-0.9 0.8-1.6 0.3-0.2 0.8-0.3 0.6-0.5 0.9-1.4 0.8-0.6 2.2-1 3.8-3.7 8.2-4.3 11.7-9.7 1.2-0.7 2.5-0.9 4.1-0.8 1-0.5 2.1-1.5 1.3 0.4 1.5-0.7 1.4-1.1 1.6-0.5 4-0.1 1.2-0.4 1.1-0.6 1.7-1.4 2.2-0.6 2.9-2.1 3.6-1.4 0.8-1.1 1.2-1.3 0.3-0.7 0.1-0.6 0.9-2.4 2.4-3.8 0.7-2.3 1.5-2 0.4-0.9 0.1-1.3-0.2-3.9-0.3-1.4-0.4-0.5-0.6-0.6-0.6-0.3-0.3 0 0.2-0.9 0.6-0.6 1.5-0.9 2.1 0.8 6.9-1.3 2.4 0.6-0.3 1.3-2.8 2.9 1 0.5 1.1 1.8 1.1 0.5 2-0.9 0.4-0.2 0.2-0.9 0.4-0.8 0.6-0.6 0.6-0.4 0.9 0 0.9 0.1 0.7-0.1 0.3-0.7-0.3-0.7-0.4-0.6-0.3-0.6 0.5-0.7-0.7-0.5-0.7-1-0.9-0.3-0.9-0.1-0.8 0.1-0.7 0.4-0.4 0.5-0.4 0-0.5-0.9 3.1-2.2 2.5-2.1 0.4-1.2 0.3-0.2 1.2 0.1 0.3-0.1 1-0.8 0.6-0.1 0.8 0.4-1.2 0.6-0.9 0.8-0.2 1 0.9 1 0.8 0.3 1-0.3 0-0.9 0.2-0.1 1.2 0 1.3-0.7 0.8-0.6 0.4-0.8 0.3-1.2-0.8-0.4 0.3-0.6 0.4-0.4 0.6-0.3 1.3-0.2-0.4 1.2 0.4 0.6 0.6 0.5 0.3 1 0.4 0 0.5-0.7 0.1-0.5-0.8-0.4 0.4-0.3 1.6-0.9 0.9-0.3 0.9-0.4 0.7-0.8-0.9 0.1-1.7 0.9-0.7-0.3 0.1-0.5 0.6-0.6 0.7-0.5-0.8 0-0.7 0.2-0.5 0.3-0.4 0.4 0.3-1.5-0.6 0.2-1.8 1.6-0.6 0.7-0.4-0.5 0.7-1.2 1-1.1 1.2-0.7 1.4-0.3 1.4 0.2 2 1 1.5 0.3 4.8 0 1.4 0.2 1.4 0.7 2.1 1.4 0.9 0.9 0.4 0.3 0.9 0.2 2.4 0 0.6 0.2 1.4 1.1 1.3 0.5 3.1 0.6 2.3 1.1 1.3 1 1.3 2.1 0.2 1.3 4.1 7 0.5 1.8 2.5 3.8 0.4 1.4-0.4 1.5-0.8 1.5-0.8 1-1.8 1.4-4.7 2.6-1.3 1.5-1 0.5-1.1 0.4-0.9 0.2-0.3 0.6-1.4 3.7-0.3 0.5-2 0-1.2 0.7-2.3 1.9-2.7 1.2-9.6 2.5-25.4 6.7-1.3 0.8-1.2 1.7-12.7 23.8-4 7.6-0.7 0.8-1.2 0.4-2.5-0.7-1.3-0.1-1.3 0.2-3.8 1.4-2.9 0.2-1.4 0.2-1.2 0.8-0.3 0.6-0.1 1.3-0.2 0.7-0.5 0.7-1.2 1.4-0.6 0.7-2.3 5.8-1.2 1.7-1.3 1.2-2.9 2-1.8 2.1-1.5 3-3.3 9.3-1.8 3-4.1 4.8-1.3 3.6-0.9 1.3-1.1 1.1-1.1 1.4-0.4 1.4-0.1 0.3z",
		color: "#CAC8C9",
		status: "Disponible"
	}
	// public path1 = "M542 799.5l0.5 1.8 0.1 0.9 6.8 10 1.1 1.1 3.4 2.6 1 1.1 1 1.9 1 1.2 0.6 1.1 0.8 2.2 0.1 0.9 0.1 1.5 0.2 1.6 3.4 3.9 6.8 6 1.8 2.3 2.5 0.8 0.8 0.5 0.4 0.8 0.4 1 0.7 1 1.3 0.9 1.4 0.9 3.6 1.1 1.3 0 1-0.1 1-0.4 1.5-1 1-1.6 1.5-1.2 1.4-1.5 1-0.9 2.1-0.9 0.9-0.6 0.4-0.8 0.3-0.9 0-0.8-0.3-1.3 0.2-0.7 0.5-1.2 0.2-1.1 0.2-0.7 0.9-1.1 0.5-0.2 1.2-0.3 0.3-0.3 0.2-0.6 0.5-0.2 0.8 0.3 1.1 0.7 0.9 1.2 1 0.8 1.5-2.3 0-0.6 2.4-0.5 2.2 0.9 1 0.6 1.9 1.7 5.5 3.6 1.7 0.5 2.2 0.3 0.9 0.4 3.1 2.9 0.7 1.1 0.3 1.2 0.1 2.1 0.2 1.1 0.4 0.9 0.7 0.5 1.1 0.1 0.9 0.3 0.5 1.3 0.2 2.1 0.3 0.4 0.7 0.3 0.7-0.2 0.5-0.5 0.5 0 0.5 1.4-0.1 1-0.3 1.2-0.1 1.1 0.7 0.7 1.9 0.6 0.6 0.6 1.2 2.7 0.5 0.6 4.6 0.3 1.2 0.3 3.1 1.1 0.5 0.4 0.4 0.6 0.4 1.4 0.6 0.4 2.8 0.3 1.1 0.6 0.8 1.5 0.4 2.7 0.5 1.1 1 0.8 0.5-0.2 0.3-0.6 0.5-0.2 1.1 0.7 0.8 1 0.4 1-0.1 1.1-0.6 0.9 0 1.6 2.2 1.7 2.6 1.6 1.5 1.3-0.1 1-0.3 1.2-0.2 1.1 0.3 0.9 1 0 2.1-1.4 1 0.2 0.7 1.2 0.5 1.2 0.8 0.9 1.5 0.5 0.8 0.6 1.4 2.4 0.8 0.9 6.8 3.2 3.4 2.2 0.8 0 0.7-0.4 1.1-0.4 0.6 0.1 1.2 0.4 0.6 0.1 0.7-0.1 2.1-0.6 0.8 0.2 1.5 1 2.3 0.8 2.1 1.9-4.5 4.5-3.5 1.9-12.4 5.5-4.3 2.9-2.5 2.9-0.8 2.9-1 2.1-1.4 1.4-2.1 0.9-2.6 0.5-9.2-0.1-2.1 0.3-1.6 0.8-2.6 2.5-3.6 1.9-1 1.1-2.1 3.5-1.2 1.6-1.5 1.5-1.2 1.8-0.4 2.1 0 2.4 0.1 1.9-0.3 1.7-0.8 0.8-1.8 1.5-3 0.5-2.3-1.5-2.1-2.1-2.1-1.3-1.7 0.7-2.1 1.9-3.2 3.6-0.9 1.5-0.7 0.9-1 0.1-1.7-0.8-1.7-1.1-7.1-5.8-2-0.8-1.9 0.4-2.5 1.6-4.6 0.9-7.6-5.1-4.1 2.9-1.5 1.6-1.6 0.5-1.8 0-2.3 0.5-2.7-0.2-2.6-2-2.5-2.5-2.2-1.7-1.2-0.4-0.6 0.2-0.6 0.5-1.1 0.7-1.5 0.2-3.1-0.1-3 0.2-5-0.8-0.9-0.5-0.5-0.9-0.8-2-0.6-0.5-0.7-0.1-1.6 0.1-0.5-0.1-0.5-0.4-0.1-0.5 0.3-1.3-0.1-0.4-0.4-0.4-0.8-0.1-0.4-0.2-1.9-1.2-1.2-0.5-1 0-1.9 1-0.9 0.4-1.2 0-5.1-1-5.3-1.5-3.2-1.4-1.4-1-2.2-2.6-3.7-2.7-1.2-0.6-1.2 0.3-1.1 0.5-1.2 0-0.4-0.5-0.3-1.3-0.3-0.5-0.6-0.3-1.5 0.1-0.7 0.1-0.5 0.2-0.5 0.1-0.8-0.4-0.5-0.6-0.3-0.6-0.6-2-0.2-1-0.4-0.7-0.7-0.5-2.4-1.2-1.4-0.3-2.3 0.9-1.1 0-0.6-0.8-0.1-1-0.2-1-1.2-0.5-1 0.4-0.7 2-1 0.5-1.1-0.3-0.6-0.4-0.6-0.2-1.2 0.3-1.1 0.1-1.3-0.2-1.4-0.4-0.9-0.5-0.4-0.6-0.4-1.5-0.4-0.5-0.5-0.3-1 0-1.1-0.2-0.6 0.1-0.4-0.3-0.3-0.9-0.3-1.7-0.8-1.4 0.1-0.5 0.4-0.5 0.9-1.7 0.4-0.5-0.3-0.4-1.3-0.4-0.9-0.6 0.2-0.8 0.6-0.8 0.4-0.8-0.4-2.8-1.6-2-2.4-1.3-7.6-1.4-4.3-2.4-2.9-0.9-0.5-0.7-0.3-2.3-1-3.1-0.1-0.9 0.4-4.6-0.7-1.8-2.6-0.5-1.3 0.4-0.6 0-0.7-0.1-0.2-0.4-0.2-1.1-0.2-0.4-0.9-0.4-0.7 0-1.7 0.7-2.3 0.5-1.4-0.5-1.1-1.4-0.9-2.3-0.2-1.2 0.4-2.2 0-1.2-0.4-1.1-1.6-1.9-0.6-1-0.1-0.7 0.2-1.3-0.3-0.7-0.6-0.6-0.7-0.5-1.6-0.7-1.3-0.3-3.8 0.5-5.7-0.4-2.7-1-4.1-4.3-2.7-1.3-3.1-0.4-4.6 0.4-1.2 0-1.2-0.4-1.2-0.8-1.3-0.7-2.7-0.3-1.2-0.6-3.7-4.4-0.8-1.5-0.1-1.1 0-0.9-0.3-0.9-1-0.7-1.1-0.3-2.6 0.2-1.2 0-1.8-0.8-1-0.2-0.9 0.2-6.6-6-0.7-0.2-2.6 0.5-3.1-0.6-1.2-0.7-0.8-0.9-0.8-1.6-0.1-0.8 0.8-8.8 0.2-0.8 1.3-1.7 0.5-1.1 0.4-2.3 1.5-3.3 4.2-6.6 1.3-0.9 4.3 0.7 3.4 0.1 1.7 0.3 1.7-0.3 1.4-0.6 1.2-1.2 1.1-1.4 1.2-1.2 3.5-2.5 1-1 0.9-1.6 1.3-1.5 4.4-4.8 3.3-4.5 4.5-6.7 5.1-4.6 5.1-8.1 2.1-3.5 1.5-2.8 1.4-1.2 3.1-2.2 0.7-0.4 2.5-2.8 1-1.4 0.9-2 2.2-7.6 1-1.5 0.8-0.8 0.7-0.2 0.8 0.1 2 1.1 0.8 0.3 2.2-0.7 5.7-4.4 2.3-2.6 0.5-1.2-0.5-2-1.5-1.6-1.6-1-0.6-1.7 0.4-1.3 0.8-2.1 1.3-2.4 3-3.8 3.6-3.3 0.6-0.3 1.1-0.4 6.7 2.2 3.2 0.4 1.3 0.4 1.2 0.7 0.9 0.8 0.6 1 1.9 5 1 1.5 1.3 1.2 1.3 1 0.8 1.3 0.1 2.4-3.8 14.9-0.4 3.4-0.1 2.1 0.3 2.4 0.6 1.9 1.1 1.7 4.1 4.6 1 1.5 0.7 1.4 0 1.4-0.4 1.2-1 1.4-1.5 1.6-1.3 1.7-0.7 2.1 0 2.3 0.6 3.1 1.5 3.2 2.3 2.9 2.7 1.9 39.8 14 1.9 0.3 2.5 0 6.4-0.5 5.6 0.9z"

	public acceptance_token!: any
	public institucionesFinancieras = [];
	public tipoPersona = [
		{ value: 0, name: "Natural" },
		{ value: 1, name: "Jurídica" }
	];
	public tipoDocumento = [
		{ value: "CC", name: "Cédula de ciudadanía" },
		{ value: "NIT", name: "NIT" }
	]

	appwompi: any
	llaveroWompi = {
		llave_publica: '',
		llave_privada: '',
		llave_eventos: ''
	}
	public infoTransa: any;
	public infoComprador: any;

	productosParaSlide: any[] = [];

	rutaActual: string = 'https://iegrupo.co/#'
	formNotificaciones: UntypedFormGroup;

	constructor(
		public http: HttpClient,
		private globals: Globals,
		private route: ActivatedRoute,
		private router: Router,
		private _wompi: WompiService,
		private formBuilder: UntypedFormBuilder,
		private _socketio: SocketIoService
	) {
		
		this.rutaActual += this.router.url
		console.log("ruta actual", this.rutaActual)
		this.formNotificaciones = this.formBuilder.group({
			mensaje: ['', Validators.required],
			link: ['', Validators.required],
		});
	}
	ngOnInit(): void {
		this._socketio.getMessage().subscribe( ers => {
			console.log("sx", ers)
		})
		// this.getEjemplosParaSlide()
		this.route.queryParams.subscribe(params => {
			// console.log("????", params) // https://www.angularjswiki.com/angular/get-query-parameters-in-angular/
			if (params.id) {
				this._wompi.verificarTransaccion(params.id)
				this.infoComprador = this._wompi.infoComprador
				this.infoTransa = this._wompi.infoTransa
				this.router.navigate([], {
					queryParams: {
						id: null,
						env: null
					},
					queryParamsHandling: 'merge'
				})
			}
		})
		let _urlPdf = 'http://186.118.184.14:8059/Reportes/Isearch/ecommerce_536833_remision.pdf';

	}

	enviarNotificacion(){
		// console.log("XD", this.formNotificaciones.value)
		this._socketio.enviarNotificacion('message', {mensaje: this.formNotificaciones.value.mensaje, link: this.formNotificaciones.value.link})
		//this.notificar(this.formNotificaciones.value.mensaje, this.formNotificaciones.value.link)
	}
	


	pagarConWompi() {
		this._wompi.pagarConWompi(123, 'pruebas', 'http://localhost:4200/#/devops', null, 'bogota')
	}
	crearTransaccionWompi() {
		// let headers = new HttpHeaders()
		/* headers=headers.set('content-type','application/json') */
		// headers=headers.set('Authorization', 'Bearer ' + this.globals.llaves_wompi.llave_publica)
		/* headers=headers.set('Access-Control-Allow-Origin', '*'); */

		let objetoTransa = {
			"acceptance_token": this.acceptance_token,
			"amount_in_cents": 3000000,
			"currency": "COP",
			"customer_email": "jahernandez@iegrupo.co",
			"payment_source_id": 1234,
			"redirect_url": "http://localhost:4200/#/devops",
			"reference": "nana",
		}
		// console.log("cabeceras", headers)
		this.http.post(this.globals.urlWompi + '/transactions', {
			body: objetoTransa,
			/* responseType: 'json',
				observe: 'body', */
			/* headers: headers */
		}).subscribe((resData: any) => {
			console.log("que pajóooooo ???? ", resData)
		})
	}
	getEjemplosParaSlide() {
		this.http.get('https://ie-vie.com:3000/api/productos/categoria/12000000/marca/981/1/12').subscribe((resData: any) => {
			this.productosParaSlide = resData.productos;
		});
	}
}
